import { render, staticRenderFns } from "./RelatedDocumentsItem.vue?vue&type=template&id=6768cbeb&scoped=true&"
import script from "./RelatedDocumentsItem.vue?vue&type=script&lang=js&"
export * from "./RelatedDocumentsItem.vue?vue&type=script&lang=js&"
import style0 from "./RelatedDocumentsItem.vue?vue&type=style&index=0&id=6768cbeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768cbeb",
  null
  
)

export default component.exports